"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Staff_exports = {};
__export(Staff_exports, {
  default: () => Staff_default
});
module.exports = __toCommonJS(Staff_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M10.4805 9.72266C11.457 9.72266 12.2969 9.38411 13 8.70703C13.7031 8.01693 14.0547 7.1901 14.0547 6.22656C14.0547 5.27604 13.7031 4.46224 13 3.78516C12.2969 3.09505 11.457 2.75 10.4805 2.75C9.49089 2.75 8.64453 3.09505 7.94141 3.78516C7.2513 4.46224 6.90625 5.27604 6.90625 6.22656C6.90625 7.1901 7.2513 8.01693 7.94141 8.70703C8.64453 9.38411 9.49089 9.72266 10.4805 9.72266ZM10.4805 3.84375C11.1445 3.84375 11.7174 4.07812 12.1992 4.54688C12.681 5.01562 12.9219 5.57552 12.9219 6.22656C12.9219 6.89062 12.681 7.45703 12.1992 7.92578C11.7174 8.39453 11.1445 8.62891 10.4805 8.62891C9.80339 8.62891 9.22396 8.39453 8.74219 7.92578C8.26042 7.45703 8.01953 6.89062 8.01953 6.22656C8.01953 5.57552 8.26042 5.01562 8.74219 4.54688C9.22396 4.07812 9.80339 3.84375 10.4805 3.84375ZM13.0781 11.207H7.92188C7.34896 11.207 6.8151 11.3112 6.32031 11.5195C5.82552 11.7148 5.39583 11.9883 5.03125 12.3398C4.66667 12.6784 4.3737 13.082 4.15234 13.5508C3.94401 14.0195 3.83984 14.5143 3.83984 15.0352V16.3633C3.83984 16.5195 3.89193 16.6497 3.99609 16.7539C4.11328 16.8581 4.25 16.9102 4.40625 16.9102C4.5625 16.9102 4.69271 16.8581 4.79688 16.7539C4.90104 16.6497 4.95312 16.5195 4.95312 16.3633V15.0352C4.95312 14.2799 5.23958 13.6419 5.8125 13.1211C6.39844 12.5872 7.10156 12.3203 7.92188 12.3203H9.52344V12.8477C9.52344 12.9258 9.54297 12.9974 9.58203 13.0625C9.62109 13.1146 9.67318 13.1536 9.73828 13.1797L10.3047 13.4727L9.77734 13.8828C9.69922 13.9219 9.63411 13.974 9.58203 14.0391C9.54297 14.1042 9.52344 14.1758 9.52344 14.2539V16.4414C9.52344 16.5456 9.5625 16.6367 9.64062 16.7148C9.71875 16.7799 9.8099 16.8125 9.91406 16.8125H11.0469C11.151 16.8125 11.2357 16.7799 11.3008 16.7148C11.3789 16.6367 11.418 16.5456 11.418 16.4414V14.2539C11.418 14.1758 11.3919 14.1042 11.3398 14.0391C11.3008 13.974 11.2422 13.9219 11.1641 13.8828L10.6172 13.4727L11.2227 13.1797C11.2747 13.1536 11.3203 13.1146 11.3594 13.0625C11.3984 12.9974 11.418 12.9258 11.418 12.8477V12.3203H13.0781C13.8984 12.3203 14.5951 12.5872 15.168 13.1211C15.7539 13.6419 16.0469 14.2799 16.0469 15.0352V16.3633C16.0469 16.5195 16.099 16.6497 16.2031 16.7539C16.3073 16.8581 16.4375 16.9102 16.5938 16.9102C16.75 16.9102 16.8802 16.8581 16.9844 16.7539C17.1016 16.6497 17.1602 16.5195 17.1602 16.3633V15.0352C17.1602 14.5143 17.056 14.0195 16.8477 13.5508C16.6263 13.082 16.3333 12.6784 15.9688 12.3398C15.6042 11.9883 15.1745 11.7148 14.6797 11.5195C14.1849 11.3112 13.651 11.207 13.0781 11.207Z",
      fill: "currentColor"
    }
  )
);
const SvgStaff = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Staff_default = SvgStaff;
